import { AlertTriangle } from 'lucide-react';

export function LoadingRows({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="loading-stack" aria-label={label}>
      <div />
      <div />
      <div />
    </div>
  );
}

export function EmptyState({ title, body }: { title: string; body: string }) {
  return (
    <section className="state-panel">
      <AlertTriangle size={22} aria-hidden="true" />
      <h2>{title}</h2>
      <p>{body}</p>
    </section>
  );
}
